module.exports = __webpack_public_path__ + "static/media/g-1-d.51591601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-1-d.jpg
// module id = 1127
// module chunks = 33